import { Component, ViewChild, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import {
  ApexAxisChartSeries,
  ApexChart,
  ChartComponent,
  ApexTitleSubtitle,
  ApexDataLabels,
  ApexStroke,
  ApexYAxis,
  ApexXAxis,
  ApexPlotOptions,
  ApexTooltip,
  ApexResponsive
} from "ng-apexcharts";
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { CompanyLineDetailViewModel } from '../../interface/company-client.interface';

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  xaxis: ApexXAxis;
  stroke: ApexStroke;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  yaxis: ApexYAxis;
  tooltip: ApexTooltip;
  colors: string[];
  title: ApexTitleSubtitle;
  subtitle: ApexTitleSubtitle;
  responsive: ApexResponsive[];
};

@Component({
  selector: 'app-line-detail-chart',
  templateUrl: './line-detail-chart.component.html',
  styleUrls: ['./line-detail-chart.component.scss']
})
export class LineDetailChartComponent implements OnInit, OnChanges{
  @ViewChild("companySummaryChart") companySummaryChart: ChartComponent;
  public chartOptions: Partial<ChartOptions>;
  @Input() companyLineSummary: CompanyLineDetailViewModel | null;

  exclamationIcon = faExclamationTriangle;
  constructor() {
  }

  ngOnInit(): void {
    
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(this.companyLineSummary){
      this.setSummaryChart(this.companyLineSummary);
    }
  }


  private setSummaryChart(summary: CompanyLineDetailViewModel){
    this.chartOptions = {
      series: [
        {
          name: "Total",
          data: [summary.amountMora, summary.amountVencido, summary.approvedLine]
        }
      ],
      chart: {
        toolbar:{
          show: false,
        },
        type: "bar",
        height: 140
      },
      plotOptions: {
        bar: {
          horizontal: true
        }
      },
      dataLabels: {
        enabled: false
      },
      xaxis: {
        labels:{
          rotate: 0
        },
        categories: [
          "Monto en mora",
          "Monto vencida",
          "Línea aprobada",
        ]
      },
      responsive: [{
        breakpoint: 600,
        options: {
          xaxis: {
            labels: {
              rotate: -45,
              skip: 2
            }
          }
        }
      }],
      tooltip: {
        enabled: true,
        shared: true,
        intersect: false,
        x: {
          formatter: function (val) {
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
          }
        }
      }
    };
  }
}
